import { useEffect } from "react";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../../../store";
import { setSelectedTimezoneAbb } from "../../../redux/slices/customerSlice";

export const useTimezoneHandler = (selectedTimezone: string) => {
    const dispatch = useDispatch<AppDispatch>();

    const getAbbreviation = (tz: string) => {
        if (!tz) return "PST";
        try {
            const abbreviation = new Intl.DateTimeFormat("en-US", {
                timeZone: tz,
                timeZoneName: "short"
            }).formatToParts(new Date()).find((part) => part.type === "timeZoneName")?.value;

            if (abbreviation) return abbreviation;

            const offset = new Intl.DateTimeFormat("en-US", {
                timeZone: tz,
                timeZoneName: "longOffset"
            }).formatToParts(new Date()).find((part) => part.type === "timeZoneName")?.value;

            return offset || "UTC";
        } catch {
            return "UTC";
        }
    };

    useEffect(() => {
        if (selectedTimezone) {
            const abbreviation = getAbbreviation(selectedTimezone);
            dispatch(setSelectedTimezoneAbb(abbreviation ?? "PST"));
        }
    }, [selectedTimezone, dispatch]);

    return { getAbbreviation };
};